/**
 * Der Aufgaben-Container initialisiert {@link v3sWbtPlayerApp:exercise.service_v3sExerciseService} und ermöglicht den Aufgaben-Elementen die Kommunikation zwischeneinander.
 * @class directive_v3sExercise
 * @memberOf v3sWbtPlayerApp:exercise
 * @param {number} v3s-attempts=2 - Anzahl der max. Versuche
 * @param {string} v3s-mode=manual - Auswertungsmodus ("manual", "instant");<br>
 * falls WBT Instant-Modus hat, dann wird der Aufgaben-Modus der Seite ignoriert
 * @param {string} v3s-type - Aufgabentyp ("input", "sc", "hotspot", ...)
 * @example
 * <v3s-exercise v3s-type="sc" v3s-attempts="2" v3s-mode="instant">...</v3s-exercise>
 */
angular.module('v3sWbtPlayerApp').directive('v3sExercise', ["v3sExerciseService", "v3sWbtDataService", function (v3sExerciseService, v3sWbtDataService) {
    return {
        restrict: 'E',
        scope: {
            v3sAttempts: '@',
            v3sMode: '@',
            v3sType: '@',
            v3sDifficulty : '@'
        },
        controller: ["$scope", "$element", function ($scope, $element) {

            // initialisiert v3sExerciseService
            var instantMode = ($scope.v3sMode === "instant") || v3sWbtDataService.getWbt().instantMode;
            var maxAttempts = parseInt($scope.v3sAttempts);
            var exDifficulty = $scope.v3sDifficulty || null;

            maxAttempts = maxAttempts > 0 ? maxAttempts : 2;


            v3sExerciseService.init($scope.$parent.currentPage, $scope.v3sType, instantMode, maxAttempts, exDifficulty);

            $scope.$on('$destroy', function () {
                v3sExerciseService.destroy();
            });


            $scope.answer = { id: '' };
            var answerElements = [];
            /**
             * Übergibt das answer property aus dem Scope an das Scope der aufrufenden Direktive
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param scope - scope der aufrufenden Direktive
             */
            this.bindAnswerId = function (scope) {
                scope.answer = $scope.answer;
            }

            /**
             * Addiert das pbergebene answerElement an das answerElements array
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param answerElement
             */
            this.addAnswer = function (answerElement) {
                answerElements.push(answerElement);
            }

            this.decisionSettings = {};
            /**
             * Ergänzt die übergebenen Parameter im decisionsSettings Objekt
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {object} d - Das Objekt mit den decision settings
            **/
            this.setDecisionSettings = function (d) {
                angular.extend(this.decisionSettings, d);
            }

            /**
             * Connectable Elemente
             */
            this.connectables = [];

            /**
             * Ergänzt die übergebenen Parameter im connectables array
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {object} conn - die v3sConnectable Direktive
             */
            this.addConnectable = function (conn) {
                this.connectables.push(conn);
            }

            /**
             * Gibt das Array this.connectables zurück
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             */
            this.getConnectables = function () {
                return this.connectables;
            }
            

            /**
             * PnP Aufgaben
             */
            /**
             * Speichert alle Sourceelemente
             */
            this.sources = [];


            /**
             * Schreibt eine Source in das sources array
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {object} s  - Das SourceElement
             */
            this.addSourceElement = function (s) {
                this.sources.push(s);
            }

            this.updateSourceStates = function () {
                var self = this;
                angular.forEach(self.sources, function (s) {
                    s.checkAnswer();
                })
            }

            /**
             * Hängt ein DOM-Element in die Exercise Direktive
             *
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {object} e 
             */
             this.appendElement = function(e){
                 $element.append(e);
             }

            /**
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             */
            this.getSourceElements = function () {
                return this.sources;
            }
            /**
             * Speichert die Targets
             */
            this.targets = [];

            /**
             * Schreibt ein Target in das targets array
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {array} conns - Das zu speichernde Array
             */
            this.addTarget = function (t) {
                this.targets.push(t);
            }

            /**
             * Gibt das targets Array zurück
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             */
            this.getTargets = function () {
                return this.targets;
            }

            /**
             * Findet ein TargetElement per Id
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             */
            this.getTargetById = function (id) {
                var theTarget = null;
                angular.forEach(this.targets, function (t) {
                    if (t.id == id) {
                        theTarget = t;
                    }
                });
                return theTarget;
            }
            


            /**
             * Hier werden die Verbindungen für CN-Aufgaben "gespeichert"
             */
            this.connections = null;

            /**
             * schreibt die Verbindungen in das connections array
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             * @param {array} conns - Das zu speichernde Array
             */
            this.setConnections = function (conns) {
                this.connections = conns;
            }
            
            /**
             * Gibt das connections Array zurück
             * @memberOf v3sWbtPlayerApp:exercise.directive_v3sExercise
             */
            this.getConnections = function () {
                return this.connections;
            }

            this.exercise = {};

            $scope.$watch('answer.id', function () {
                if (!!$scope.answer.id) {
                    var selectedAnswerElement = null;
                    angular.forEach(answerElements, function (answerElement) {
                        //Falls das AnswerElement schon completed ist, muss nichts geändert werden
                        if (!answerElement.completed) {
                            if ($scope.answer.id === answerElement.id) {
                                selectedAnswerElement = answerElement;
                            } else {
                                answerElement.setUserAnswer(false);
                                answerElement.showFeedback(false);
                            }
                        }
                    });
                    if(!!selectedAnswerElement) selectedAnswerElement.setUserAnswer(true);
                }
            });

        }],
        link: function (scope, element, attrs) {
        }
    }
}]);
